import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import { User, ApiResponse } from '@magnetar/admin-api-interfaces'

interface CreateUserData {
  user_name: string
  account: string
  password?: string
  user_role_id?: number
  is_active: boolean
  email?: string | null
  provider_id?: number
}

interface UpdateUserData {
  user_name: string
  account: string
  password?: string
  user_role_id?: number
  is_active: boolean
  email?: string | null
}

export const userService = {
  getUserPermissions: async (token: string) => {
    try {
      const response = await apiClient.get<
        ApiResponse<{ permissions: Array<{ module: string; allowed_action: string[] }> }>
      >('/api/me/permissions', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'GET_PERMISSIONS_FAILED',
          message: '取得權限失敗',
        },
      }
    }
  },

  createUser: async (data: CreateUserData, token: string) => {
    try {
      const response = await apiClient.post<ApiResponse<User>>('/api/users', data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'CREATE_USER_FAILED',
          message: '建立使用者失敗',
        },
      }
    }
  },

  updateUser: async (userId: number, data: UpdateUserData, token: string) => {
    try {
      const response = await apiClient.put<ApiResponse<User>>(`/api/users/${userId}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'UPDATE_USER_FAILED',
          message: '更新使用者失敗',
        },
      }
    }
  },

  deleteUser: async (userId: number, token: string) => {
    try {
      const response = await apiClient.delete<ApiResponse<void>>(`/api/users/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'DELETE_USER_FAILED',
          message: '刪除使用者失敗',
        },
      }
    }
  },

  changeMyPassword: async (
    data: { old_password: string; new_password: string; new_password_confirm: string },
    token: string,
  ) => {
    try {
      const response = await apiClient.post<ApiResponse<null>>(
        '/api/users/me/change-password',
        data,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'CHANGE_PASSWORD_FAILED',
          message: '變更密碼失敗',
        },
      }
    }
  },

  updateProfile: async (
    data: { user_name: string; email?: string },
    token: string,
  ) => {
    try {
      const response = await apiClient.put<
        ApiResponse<{ user: { user_id: number; user_name: string; email: string | null } }>
      >('/api/me/profile', data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'UPDATE_PROFILE_FAILED',
          message: '更新個人資料失敗',
        },
      }
    }
  },
}
